import React, { useEffect, useState } from "react";
import "../../App.css";
import { useSpring, animated } from "@react-spring/web";
import {
  MinusOutlined,
  PlusOutlined,
  ArrowLeftOutlined,
  DeleteOutlined
} from "@ant-design/icons";
import { useAuth } from "../../contexts/AuthContext";
import { useTranslation } from "../../i18n/useTranslation";

export default function CartModal({ setIsOpen, onValidate, onBack }) {
  const {
    basket,
    clearBasket,
    basketTotalPrice,
    updateBasketQty,
    language,
    currentRestaurant,
  } = useAuth();

  const { t } = useTranslation();
  const [stockError, setStockError] = useState("");
  const isDigitalProduct = currentRestaurant?.productType === "digital";

  useEffect(() => {
    if (!basket || basket.length === 0) setIsOpen(false);
  }, [basket, setIsOpen]);

  const springs = useSpring({ from: { y: 600 }, to: { y: 0 } });

  const inc = (e, item, index) => {
    e.stopPropagation();

    const availableQuantity = Number(item?.product?.quantity || 0);
    const currentQuantity = Number(item?.quantity || 1);

    if (currentQuantity >= availableQuantity) {
      setStockError(
        `Stock insuffisant pour ${
          item?.product?.name || "ce produit"
        }. Disponible : ${availableQuantity}`
      );
      return;
    }

    setStockError("");
    updateBasketQty(index, currentQuantity + 1);
  };

  const dec = (e, item, index) => {
    e.stopPropagation();
    setStockError("");
    updateBasketQty(index, (item.quantity || 0) - 1);
  };

  const minOrderPrice = Number(currentRestaurant?.minOrderPrice || 0);
  const isBelowMinimum = basketTotalPrice < minOrderPrice;
  const isRestaurantClosed = currentRestaurant?.isOpen === false;
  const cannotValidate = isRestaurantClosed || isBelowMinimum;

  return (
    <div className="product-modal-container" onClick={() => setIsOpen(false)}>
      <animated.div
        className="product-modal-content cart-modal"
        style={{ ...springs }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-text-container modal-container">
        <div className="modal-header-container payment-header">
  <ArrowLeftOutlined
    className="payment-back"
    onClick={() => (onBack ? onBack() : setIsOpen(false))}
  />

  <p className="modal-text-header payment-title">
    {t("your_order")}
  </p>

  <DeleteOutlined
    className="payment-back"
    onClick={(e) => {
      e.stopPropagation();
      clearBasket();
      setIsOpen(false);
    }}
  />
</div>
        </div>

        <div className="modal-text-container cart-body-scroll">
          <div className="cart-list">
            {basket.map((item, index) => {
              const availableQuantity = Number(
                item?.product?.quantity || 0
              );
              const currentQuantity = Number(item?.quantity || 1);
              const isMaxReached = currentQuantity >= availableQuantity;

              return (
                <div key={item.key || index} className="cart-container">
                  <div className="cart-item">
                    <div>
                      <div className="cart-row">
                        <p className="cart-row-name">
                          {item.product?.name}
                        </p>

                        {item.selections?.option && (
                          <div className="subtext">
                            {language
                              ? item.selections.option.translations !== undefined
                                ? item.selections.option.translations[language]
                                : item.selections.option.name
                              : item.selections.option.name}
                          </div>
                        )}
                      </div>

                      {item.selections?.supplements?.length > 0 && (
                        <div className="subtext">
                          {item.selections.supplements.map((s, i) => (
                            <div key={i}>
                              {language
                                ? s.translations !== undefined
                                  ? s.translations[language]
                                  : s.name
                                : s.name}
                            </div>
                          ))}
                        </div>
                      )}

                      {isMaxReached && availableQuantity > 0 && (
                        <div
                          className="subtext"
                          style={{ color: "#c0392b" }}
                        >
                          Stock maximum atteint
                        </div>
                      )}

                      {availableQuantity === 0 && (
                        <div
                          className="subtext"
                          style={{ color: "#c0392b" }}
                        >
                          Rupture de stock
                        </div>
                      )}
                    </div>

                    <div className="cart-controls">
                    {!isDigitalProduct && (
  <div className="modal-quantity">
    <MinusOutlined onClick={(e) => dec(e, item, index)} />
    <p>{currentQuantity}</p>
    <PlusOutlined
      onClick={(e) => inc(e, item, index)}
      style={{
        opacity: availableQuantity === 0 || isMaxReached ? 0.4 : 1,
        pointerEvents: availableQuantity === 0 || isMaxReached ? "none" : "auto",
      }}
    />
  </div>
)}

                      <p className="cart-controls-price">
                        {(item.pricing?.totalPrice || 0).toFixed(2)} €
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {stockError && (
            <p className="auth-error" style={{ marginTop: 12 }}>
              {stockError}
            </p>
          )}

          {isBelowMinimum && !isRestaurantClosed && (
            <p className="auth-error" style={{ marginTop: 12 }}>
            </p>
          )}
        </div>

        <div className="modal-close-container">
          <div
            className="modal-close-button"
            onClick={(e) => {
              e.stopPropagation();
              if (cannotValidate) return;
              onValidate();
            }}
           
          >
            {isRestaurantClosed
              ? "Boutique fermée"
              : isBelowMinimum
              ? `Minimum ${minOrderPrice.toFixed(2)} €`
              : `${t("validate_cart")} · ${basketTotalPrice.toFixed(2)} €`}
          </div>
        </div>
      </animated.div>
    </div>
  );
}